import { render } from "./IUserMultiPicker.vue?vue&type=template&id=2af1a4bb"
import script from "./IUserMultiPicker.vue?vue&type=script&lang=js"
export * from "./IUserMultiPicker.vue?vue&type=script&lang=js"

import "./IUserMultiPicker.vue?vue&type=style&index=0&id=2af1a4bb&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__